module.exports = __webpack_public_path__ + "static/img/NICK-WATSON.56af0e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NICK-WATSON.jpg
// module id = 9SQb
// module chunks = 0